import React, { useEffect, useState } from "react"
import "./GoogleTranslateStyle.scss"

declare global {
  interface Window {
    google: any
    googleTranslateElementInit?: () => void
  }
}

const GoogleTranslate = ({ setIsVisible }) => {
  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google?.translate) {
        new window.google.translate.TranslateElement(
          {
            autoDisplay: false,
            layout:
              window.google.translate.TranslateElement.InlineLayout.HORIZONTAL,
          },
          "google_translate_element"
        )
      }
    }

    const existingScript = document.getElementById("google-translate-script")
    if (!existingScript) {
      const script = document.createElement("script")
      script.id = "google-translate-script"
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
      script.async = true
      script.setAttribute("nonce", "DhcnhD3khTMePgXw")
      document.body.appendChild(script)
    } else {
      if (window.google?.translate?.TranslateElement) {
        window.googleTranslateElementInit?.()
      }
    }

    const container = document.getElementById("google_translate_element")
    const cleanUpTranslateElement = () => {
      if (!container) return

      const anchors = container.querySelectorAll("a")
      anchors.forEach(a => a.remove())

      const spans = container.querySelectorAll("span")
      spans.forEach(span => span.remove())

      const selectEl = document.querySelector(
        ".goog-te-combo"
      ) as HTMLSelectElement | null
      if (selectEl) {
        const options = selectEl.querySelectorAll("option")
        options.forEach(option => {
          if (
            option.value === "" &&
            (option.innerText === "Pumili ng Wika" ||
              option.innerText === "Select Language")
          ) {
            option.remove()
            selectEl.value = "en"
          }
        })
      }

      const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        null
      )

      let node = walker.nextNode()
      if (node) {
        if (node.nodeValue?.includes("Pinapagana ng")) {
          node.nodeValue = node.nodeValue.replace("Pinapagana ng", "")
        }

        if (node.nodeValue?.includes("Powered by")) {
          node.nodeValue = node.nodeValue.replace("Powered by", "")
        }

        if (node.nodeValue?.includes("Translated by")) {
          node.nodeValue = node.nodeValue.replace("Translated by", "")
        }
        node = walker.nextNode()
      }
    }

    const observer = new MutationObserver(() => {
      cleanUpTranslateElement()
    })

    const targetNode = document.getElementById("google_translate_element")
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      })
    }

    const handleOnClickChange = (event: Event) => {
      const target = event.target as HTMLElement

      if (target) {
        setIsVisible(false)
      }
    }

    container?.addEventListener("change", handleOnClickChange)

    return () => {
      observer.disconnect()
      container?.removeEventListener("change", handleOnClickChange)
    }
  }, [])

  return <div id="google_translate_element"></div>
}

export default GoogleTranslate
